import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";
import Logo from "@/components/Logo";

export default function Header() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const navigate = useNavigate();
  const onPublic = loc.pathname.startsWith("/broker/respond");
  if (onPublic) return null;

  const isAuthed = user && typeof user === "object";

  return (
    <header className="border-b border-gray-200 bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
          <Logo size={32} />
          <span className="font-display font-bold text-lg text-gray-900 tracking-tight">
            borra-me<span className="text-[#DC2626]">.</span>com
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/#precio" data-testid="nav-pricing" className="text-gray-700 hover:text-gray-900">Precios</Link>
          <Link to="/blog" data-testid="nav-blog" className="text-gray-700 hover:text-gray-900">Blog</Link>
          <Link to="/#faq" data-testid="nav-faq" className="text-gray-700 hover:text-gray-900">FAQ</Link>
          <a href="https://leydedatoschile.com" target="_blank" rel="noreferrer" data-testid="nav-ldch" className="text-gray-700 hover:text-gray-900">Ley 21.719 ↗</a>
        </nav>

        <div className="flex items-center gap-3">
          {isAuthed ? (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm text-gray-700 hover:text-gray-900">Dashboard</Link>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-admin" className="text-sm text-gray-700 hover:text-gray-900">Admin</Link>
              )}
              <button
                data-testid="nav-logout"
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-sm flex items-center gap-1.5 text-gray-700 hover:text-gray-900"
              >
                <LogOut className="w-3.5 h-3.5" /> Salir
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm text-gray-700 hover:text-gray-900">Ingresar</Link>
              <Link to="/register" data-testid="nav-register" className="text-sm bg-[#0B2447] text-white px-4 py-2 rounded-md hover:bg-[#071932] transition-colors">
                Crear cuenta
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
